import { jsx } from '@emotion/react';
import clsx from 'clsx';
import isObject from 'lodash-es/isObject';
import { cloneElement } from 'react';

/**
 * Clones an element with Emotion's `css` prop support. This is a somewhat hacky solution, but it's
 * a workaround for the fact that `cloneElement` doesn't work with the `css` prop out of the box.
 * @see https://github.com/emotion-js/emotion/issues/1102
 *
 * @param element - The element to clone.
 * @param props - The props to merge into the cloned element.
 */ function cloneElementWithCss(element, props) {
    const hasCssProp = (props)=>isObject(props) && 'css' in props;
    return hasCssProp(element.props) ? cloneElement(element, {
        ...props,
        css: [
            element.props.css,
            hasCssProp(props) && props.css
        ],
        className: clsx(element.props.className, hasCssProp(props) && props.className)
    }) : jsx(element.type, {
        key: element.key,
        ref: element.ref,
        ...element.props,
        ...props
    });
}

export { cloneElementWithCss };
//# sourceMappingURL=clone-element-with-css.js.map
